// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"bdde8872","640":"0c4cee2c","904":"4fe76570"}[chunkId] + ".chunk.js";
};